
import { useState, useRef } from "react";

/**
 * This is a single row with a vertical bar to separate left and right column and we can move the bar left or right to change width of components
 * - leftPanelWidth is width of left panel in percentage of screen width
 * - rest 100-leftPanelWidth is right panel width
 * 
 */
export default function SplitPanel({ leftPanelWidth=40, leftComponent, rightComponent }) {
  const [leftWidth, setLeftWidth] = useState(leftPanelWidth); // Initial width in percentage
  const isDragging = useRef(false);

  const handleMouseDown = () => {
    isDragging.current = true;
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  const handleMouseMove = (e) => {
    if (!isDragging.current) return;
    let newWidth = (e.clientX / window.innerWidth) * 100;
    // keep new width between 10 and 90
    if(newWidth<10)newWidth=10
    if(newWidth>90)newWidth=90
    setLeftWidth(newWidth);
  };

  const handleMouseUp = () => {
    isDragging.current = false;
    document.removeEventListener("mousemove", handleMouseMove);
    document.removeEventListener("mouseup", handleMouseUp);
  };

  return (
    <div className="flex w-full  ">
      {/* Left Component */}
      <div style={{ width: `${leftWidth}%` }} 
      className="max-h-screen overflow-y-visible">
        {leftComponent}
      </div>

      {/* Resizable Divider */}
      <div
        className="w-2  bg-gray-200 m-2 cursor-col-resize hover:bg-gray-300 rounded-lg bg-[radial-gradient(circle,gray_20%,transparent_30%)]"
        onMouseDown={handleMouseDown}
      />

      {/* Right Component */}
      <div
        style={{ width: `${100 - leftWidth}%` }}
        className="justify-end h-full "
      >
        {rightComponent}
      </div>
    </div>
  );
}
